//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetUrlUpgradePackageAPISuccess, ActionGetUrlEliteRedirectAPISuccess } from './actions';
export interface UrlUpgradePackageState {
    url?: string
    urElite?: string
}

const defaultState: UrlUpgradePackageState = {
    url: undefined,
    urElite: undefined
};


type UrlUpgradePackageAction = ActionGetUrlUpgradePackageAPISuccess | ActionGetUrlEliteRedirectAPISuccess;

function urlUpgradePackageReducer(state: UrlUpgradePackageState = defaultState, action: UrlUpgradePackageAction): UrlUpgradePackageState {
    switch (action.type) {
        case ACTIONS.GET_URLUPGRADE_PACKAGE_API_SUCCESS:
            {
                const { url } = action as ActionGetUrlUpgradePackageAPISuccess;
                return {
                    ...state,
                    url: url
                }
            }
        case ACTIONS.GET_ELITE_REDIRECT_API_SUCCESS:
            {
                const { urElite } = action as ActionGetUrlEliteRedirectAPISuccess;
                return {
                    ...state,
                    urElite: urElite
                }
            }
    }
    return {
        ...state
    }
}

export default urlUpgradePackageReducer;